/**
 * Server-side sort vocabulary for the /Leads companies table.
 * The keys mirror the whitelist in the backend list_prospect_query_companies RPC.
 */

export const LEAD_SORT_KEYS = ['name', 'rating', 'created-at', 'revenue', 'employees', 'ai-score', 'contacts'];

export const LEAD_SORT_DIRECTIONS = ['asc', 'desc'];

export const DEFAULT_LEAD_ORDER_BY = 'created-at';
export const DEFAULT_LEAD_ORDER_DIR = 'desc';

/**
 * Default direction applied when a column is first selected: text sorts ascending
 * (A→Z), numeric / score / date columns sort descending (high/newest first).
 */
const DESCENDING_FIRST_KEYS = new Set(['rating', 'created-at', 'revenue', 'employees', 'ai-score', 'contacts']);

/**
 * Returns the default sort direction for a freshly selected column.
 * @param {string} sortKey - One of LEAD_SORT_KEYS
 * @returns {'asc'|'desc'}
 */
export const defaultDirectionForKey = (sortKey) => (DESCENDING_FIRST_KEYS.has(sortKey) ? 'desc' : 'asc');

/**
 * Validates a sort key against the whitelist, falling back to the default.
 * @param {string|null|undefined} sortKey
 * @returns {string} A valid LEAD_SORT_KEYS entry
 */
export const normalizeOrderBy = (sortKey) => (LEAD_SORT_KEYS.includes(sortKey) ? sortKey : DEFAULT_LEAD_ORDER_BY);

/**
 * Validates a sort direction, falling back to the default.
 * @param {string|null|undefined} dir
 * @returns {'asc'|'desc'}
 */
export const normalizeOrderDir = (dir) => (LEAD_SORT_DIRECTIONS.includes(dir) ? dir : DEFAULT_LEAD_ORDER_DIR);
